<div class="pl-3 pt-4 p">
  <h1 class="text-monospace text-black-50">404</h1>
  <h2 class="pt-4">{{'NotFound'|translate}}</h2>

</div>
